import Minze, { Attrs, EventListeners, MinzeElement, Reactive } from 'minze'
import { Font, SCREEN_WIDTHS } from '../../../constants'
import { Callback } from '../../../modules/callback'
import { getVisibleWidth } from '../../../modules/utils'

export interface LvcChip {
  value?: string
  selected?: boolean
  onClick?: string
  size?: string
  theme?: string
}

export class LvcChip extends MinzeElement {
  private _size: string = 'small'
  reactive: Reactive = [
    ['background', '#fff'],
    ['color', '#1E007D'],
    ['checked', false],
    ['border', '1px solid #1E007D'],
  ]
  attrs: Attrs = [
    'type',
    'on-click',
    ['responsive', null],
    ['border-radius', '99px'],
    ['border-bottom', ''],
    ['margin-bottom', ''],
    ['width', '100%'],
    'value',
    'selected',
    ['size', ''],
    'enable-hover-animation',
  ]

  static observedAttributes = ['theme', 'border', 'background', 'color', 'selected', 'value']
  isLarge() {
    let large = this.size === 'large'

    if (typeof this.responsive === 'boolean') {
      if (this.responsive && getVisibleWidth() < SCREEN_WIDTHS.MOBILE) {
        large = false
      } else {
        large = true
      }
    }
    return large
  }
  renderSelectIcon = () => {
    if (this.isLarge()) {
      return `<lvc-circle-check-select-large-icon class="icon large"></lvc-circle-check-select-large-icon>`
    } else {
      return `<lvc-circle-check-select-icon class="icon"></lvc-circle-check-select-icon>`
    }
  }

  renderUnselectIcon = () => {
    if (this.isLarge()) {
      return `<lvc-circle-check-unselect-large-icon class="icon large"></lvc-circle-check-unselect-large-icon>`
    } else {
      return `<lvc-circle-check-unselect-icon class="icon"></lvc-circle-check-unselect-icon>`
    }
  }

  onAttributeChange = (name: string, oldValue: string, newValue: string) => {
    if (name === 'theme') {
      if (newValue === 'dark') {
        this.background = '#fff'
        this.color = '#1E007D'
      } else if (newValue === 'dark-borderless') {
        this.background = '#fff'
        this.color = '#1E007D'
        this.border = 'none'
      }
    } else if (name === 'selected') {
      if (newValue === 'true') {
        this.checked = true
      } else {
        this.checked = false
      }
    }
  }

  handleClick(e: Event) {
    if (this.onClick) {
      Callback.call(this.onClick, { value: this.value })
    } else {
      Minze.cast('lvc:category-chip', { value: this.value })
    }
  }

  html = () => `
    <button class="chip ${this.responsive ? 'responsive' : ''}" type="${this.type}">
      <slot></slot>
      ${this.checked ? this.renderSelectIcon() : this.renderUnselectIcon()}
    </button>
  `

  css = () => {
    return `
      .chip {
        font-family: ${Font.family};
        width: ${this.width};
        background: ${this.background};
        color: ${this.color};
        font-size: 14px;
        font-weight: ${Font.weight.medium};
        border: ${this.border};
        border-radius: 99px;
        padding: ${this.size === 'large' ? '12px' : '0.5rem 0.5rem'};
        padding-left: ${this.size === 'large' ? '24px' : ''};
        cursor: pointer;
        height: ${this.size === 'large' ? '' : '44px'};
        border-bottom: ${this.borderBottom};
        margin-bottom: ${this.marginBottom};
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.2s ease-in-out;
        backface-visibility: hidden;
      }

      .icon {
        margin-left: 12px;
        width: 28px;
        height: 28px;
      }
      .icon.large {
        width: 48px;
        height: 48px;
      }


      .chip:hover {
        ${this.enableHoverAnimation ? `transform: scale(1.04);` : ``}
      }

      @media screen and (max-width: 540px) {
        .responsive {
          padding: 8px;
          padding-left: 16px;
        }
      }
    `
  }

  eventListeners: EventListeners = [[this, 'click', this.handleClick]]
}
